import { render } from "./ChangeDocumentDetail.vue?vue&type=template&id=39375b6c&scoped=true"
import script from "./ChangeDocumentDetail.vue?vue&type=script&lang=js"
export * from "./ChangeDocumentDetail.vue?vue&type=script&lang=js"

import "./ChangeDocumentDetail.vue?vue&type=style&index=0&id=39375b6c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39375b6c"]])

export default __exports__